import type { DocumentState } from "@/views/DocumentWorkspace/documentWorkspaceData";

const STATE_META: Record<
  DocumentState,
  { label: string; className: string; title: string }
> = {
  current: {
    label: "Current",
    className: "bg-[#DCFCE7] text-[#15803D]",
    title: "The effective version. Available to Ask Vivo.",
  },
  superseded: {
    label: "Superseded",
    className: "bg-[#F0F2F4] text-[#6B7280]",
    title:
      "Replaced by a newer version. Retained as history and excluded from Ask Vivo retrieval.",
  },
  retired: {
    label: "Retired",
    className: "bg-[#FEF3C7] text-[#B26500]",
    title:
      "Soft-retired: removed from Ask Vivo context immediately, retained in the audit record.",
  },
};

export function DocumentStateBadge({ state }: { state: DocumentState }) {
  const meta = STATE_META[state];

  return (
    <span
      title={meta.title}
      className={`inline-flex h-5 items-center rounded-[4px] px-1.5 text-[12px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
